// ============================================================================
// First-login company onboarding — UI strings (es / en / ca).
// Merged into the main bundles by lib/i18n.js (same pattern as catalogue.js).
// Sector / category / province labels live in lib/companyOnboarding.js.
// ============================================================================

const es = {
  onboard: {
    welcomeTitle: 'Te damos la bienvenida',
    welcomeSubtitle: 'Ahorra tiempo y dinero en tu gestión',
    activityQuestion: '¿Qué tipo de actividad realizas?',
    activity_autonomo: 'Autónomo',
    activity_empresa: 'Empresa',
    activity_asesoria: 'Asesoría',
    activityDesc_autonomo: 'Trabajas por cuenta propia',
    activityDesc_empresa: 'Sociedad (S.L., S.A., cooperativa…)',
    activityDesc_asesoria: 'Llevas la gestión de otros negocios',
    detailsTitle: 'Solo un paso más',
    detailsSubtitle: 'Completa tus datos de facturación. Aparecerán en tus facturas y en los datos de empresa.',
    fiscalName: 'Nombre fiscal',
    fiscalNamePhAutonomo: 'Nombre y apellidos',
    fiscalNamePhEmpresa: 'Mi Empresa S.L.',
    taxId: 'NIF/CIF',
    taxIdPk: 'NTN / CNIC',
    phone: 'Teléfono',
    address: 'Dirección de facturación',
    addressPh: 'Calle, número, piso',
    city: 'Ciudad',
    postalCode: 'Código postal',
    province: 'Provincia',
    provincePh: 'Seleccionar provincia',
    country: 'País',
    countryNote: 'El país decide los impuestos, la moneda y el sistema fiscal de la cuenta.',
    sector: 'Sector',
    sectorPh: 'Selecciona sector',
    category: 'Categoría',
    categoryPh: 'Selecciona categoría',
    continue: 'Continuar',
    saving: 'Guardando…',
    later: 'Completar más tarde',
    back: 'Atrás',
    required: 'Rellena los campos obligatorios: {{fields}}.',
    taxIdInvalid: 'El NIF/CIF «{{id}}» no parece válido. Revísalo, o pulsa Continuar otra vez para guardarlo igualmente.',
    saveError: 'No se han podido guardar los datos: {{msg}}',
  },
};

const en = {
  onboard: {
    welcomeTitle: 'Welcome',
    welcomeSubtitle: 'Save time and money running your business',
    activityQuestion: 'What kind of business do you run?',
    activity_autonomo: 'Self-employed',
    activity_empresa: 'Company',
    activity_asesoria: 'Accounting firm',
    activityDesc_autonomo: 'You work for yourself',
    activityDesc_empresa: 'Registered company or partnership',
    activityDesc_asesoria: 'You manage the books of other businesses',
    detailsTitle: 'Just one more step',
    detailsSubtitle: 'Complete your billing details. They will appear on your invoices and in your company profile.',
    fiscalName: 'Legal name',
    fiscalNamePhAutonomo: 'Full name',
    fiscalNamePhEmpresa: 'My Company Ltd',
    taxId: 'Tax ID (NIF/CIF)',
    taxIdPk: 'NTN / CNIC',
    phone: 'Phone',
    address: 'Billing address',
    addressPh: 'Street, number, floor',
    city: 'City',
    postalCode: 'Postal code',
    province: 'Province',
    provincePh: 'Select province',
    country: 'Country',
    countryNote: 'The country sets the account’s taxes, currency and tax-authority system.',
    sector: 'Sector',
    sectorPh: 'Select sector',
    category: 'Category',
    categoryPh: 'Select category',
    continue: 'Continue',
    saving: 'Saving…',
    later: 'Finish later',
    back: 'Back',
    required: 'Please fill in the required fields: {{fields}}.',
    taxIdInvalid: 'The tax ID “{{id}}” does not look valid. Check it, or press Continue again to save it anyway.',
    saveError: 'Your details could not be saved: {{msg}}',
  },
};

const ca = {
  onboard: {
    welcomeTitle: 'Et donem la benvinguda',
    welcomeSubtitle: 'Estalvia temps i diners en la teva gestió',
    activityQuestion: 'Quin tipus d’activitat fas?',
    activity_autonomo: 'Autònom',
    activity_empresa: 'Empresa',
    activity_asesoria: 'Assessoria',
    activityDesc_autonomo: 'Treballes per compte propi',
    activityDesc_empresa: 'Societat (S.L., S.A., cooperativa…)',
    activityDesc_asesoria: 'Portes la gestió d’altres negocis',
    detailsTitle: 'Només un pas més',
    detailsSubtitle: 'Completa les teves dades de facturació. Apareixeran a les teves factures i a les dades d’empresa.',
    fiscalName: 'Nom fiscal',
    fiscalNamePhAutonomo: 'Nom i cognoms',
    fiscalNamePhEmpresa: 'La Meva Empresa S.L.',
    taxId: 'NIF/CIF',
    taxIdPk: 'NTN / CNIC',
    phone: 'Telèfon',
    address: 'Adreça de facturació',
    addressPh: 'Carrer, número, pis',
    city: 'Ciutat',
    postalCode: 'Codi postal',
    province: 'Província',
    provincePh: 'Selecciona província',
    country: 'País',
    countryNote: 'El país decideix els impostos, la moneda i el sistema fiscal del compte.',
    sector: 'Sector',
    sectorPh: 'Selecciona sector',
    category: 'Categoria',
    categoryPh: 'Selecciona categoria',
    continue: 'Continuar',
    saving: 'Desant…',
    later: 'Completar més tard',
    back: 'Enrere',
    required: 'Omple els camps obligatoris: {{fields}}.',
    taxIdInvalid: 'El NIF/CIF «{{id}}» no sembla vàlid. Revisa’l, o prem Continuar una altra vegada per desar-lo igualment.',
    saveError: 'No s’han pogut desar les dades: {{msg}}',
  },
};

const onboardingStrings = { es, en, ca };
export default onboardingStrings;
